import { QuebecPurchaseCost } from '../purchase-cost'

export const PurchaseCost = { ...QuebecPurchaseCost } as const
